import slick from "./imports/slick";
import header from "./imports/header";

window.addEventListener('DOMContentLoaded', ()=>{
    header();
    slick();
})